import { render } from "./CoBrandCottage.vue?vue&type=template&id=1dc3b8fb&scoped=true"
import script from "./CoBrandCottage.vue?vue&type=script&lang=js"
export * from "./CoBrandCottage.vue?vue&type=script&lang=js"

import "./CoBrandCottage.vue?vue&type=style&index=0&id=1dc3b8fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc3b8fb"]])

export default __exports__